import { EntityApi, LoopBackAuth } from '../../../sdk';
import { FormBuilder } from '@angular/forms';
import { AbstractWidgetComponent, isNotEmpty } from '../../../utils/util';
import { DataelementApi } from '../../../sdk/services/custom';
import * as _ from 'lodash';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PushNotificationsService, NotificationsService } from 'angular2-notifications';
import { PlatformApp } from '../../../services/app.service';
@Component({
    selector: 'piechart-widget',
    templateUrl: './piechart.component.html',
    styleUrls: ['./piechart.component.scss']
})

export class PieChartComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {
    id = 'piechart' + Math.floor((Math.random() * 1000000000000) + 1);
    @Input() title = 'Portfolio of Investments';
    @Input() filters: any;
    public ddd = true;
    @Input() widget: any;
    _dataelementid = '58a1414ba4ff0b42dc3a09e6';
    _comparefield = 'amount';
    _basefield = 'investmenttype';
    notifyOptions = PlatformApp.getNotificationOptions();
    single: any[] = [];
    showLegend = false;
    fitContainer: boolean = true;

    colorScheme = {
        domain: ['#FFA726', '#1565C0', '#FFCC80', '#03A9F4']
    };
    // margin
    margin: boolean = false;
    marginTop: number = 2;
    marginRight: number = 2;
    marginBottom: number = 2;
    marginLeft: number = 2;

    // pie
    showLabels = true;
    explodeSlices = false;
    doughnut = true;

    constructor(_dataelementApi: DataelementApi, fb: FormBuilder,
        private _NotificationsService: NotificationsService, private _PushNotificationsService: PushNotificationsService,
        _loopBackAuth: LoopBackAuth, _entityApi: EntityApi) {
        super(_dataelementApi, fb, _loopBackAuth, _entityApi);
    }

    ngOnInit() {
        if (this.widget) {
            this.ddd = Boolean(this.widget.ddd);
            this._dataelementid = this.widget.dataelement;
            this._basefield = this.widget.basefield;
            this._comparefield = isNotEmpty(this.widget.comparefields) ? this.widget.comparefields[0] : this.widget.comparefield;
            this.title = this.widget.title;
            if (isNotEmpty(this.widget.filterfields)) {
            }
            this.setChartConfig();
        }
    }

    createChartConfig(result): any {
        if (result.data && result.data.length > 0) {
            this.single = [];
            result.data.forEach(d => {
                this.single.push({ 'name': d[this._basefield], 'value': d[this._comparefield] });
            });
        }
    }

    onSelect(event) {
        console.log(event);
    }

    ngOnDestroy() {
    }

    private notify(type, title?, content?, options?) {
        if (!options) options = PlatformApp.getNotificationOptions();
        if (!options.id) options.id = type + '-' + title + '_' + content;
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/piechart/piechart.component.ts